import { render } from "./ListContacts.vue?vue&type=template&id=3ddd692a&scoped=true"
import script from "./ListContacts.vue?vue&type=script&lang=js"
export * from "./ListContacts.vue?vue&type=script&lang=js"

import "./ListContacts.vue?vue&type=style&index=0&id=3ddd692a&lang=scss&scoped=true"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3ddd692a"]])

export default __exports__